import React from 'react';
import { Autocomplete, Checkbox, Chip, TextField } from '@mui/material';

const LanguageFilter = ({
  options,
  value,
  onChange,
  getOptionLabel,
  isOptionEqualToValue,
  groupBy,
  placeholder,
  error,
  checkboxes = false,
}) => (
  <Autocomplete
    multiple
    options={options}
    value={value}
    groupBy={groupBy}
    getOptionLabel={getOptionLabel}
    isOptionEqualToValue={isOptionEqualToValue}
    onChange={onChange}
    disableCloseOnSelect={checkboxes}
    renderOption={checkboxes ? (props, option, { selected }) => (
      <li {...props}>
        <Checkbox checked={selected} style={{ marginRight: 8 }} />
        {getOptionLabel(option)}
      </li>
    ) : undefined}
    renderTags={(selected, getTagProps) => selected.map((option, index) => (
      <Chip
        {...getTagProps({ index })}
        key={index}
        label={getOptionLabel(option)}
      />
    ))}
    renderInput={(params) => (
      <TextField
        {...params}
        placeholder={placeholder}
        error={error}
      />
    )}
  />
);

export default LanguageFilter;
